<div class="root-container"
     [style.width.px]="size"
     [style.height.px]="size">
    <img [src]="default ? 'assets/images/common/spinner.svg' : 'assets/images/common/spinner_red.svg'"
         [style.width.px]="size"
         [style.height.px]="size"/>
</div>
